"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const VidShareScreenIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M13 4H4.995C3.893 4 3 4.9 3 6.009v7.982C3 15.098 3.893 16 4.995 16h14.01C20.107 16 21 15.1 21 13.991V7.5 11h-2v3H5V6h8z"/><path d="M10 17h4v3h-4z"/><path d="M9 20a1 1 0 0 1 .99-1h4.02c.546 0 .99.444.99 1v1H9z"/><path fill-rule="nonzero" d="M19 5v3a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path fill-rule="nonzero" d="m19 3.586-6.707 6.707a1 1 0 0 0 1.414 1.414L20.414 5H19z"/></g></svg>`
}, props));
VidShareScreenIcon.displayName = 'VidShareScreenIcon';
var _default = exports.default = VidShareScreenIcon;